<template>
    <input-text
        label       = "Номер клиента"
        required    = "*"
        :errorText  = "authErrors.client_number ? authErrors.client_number[0] : ''"
        placeholder = "xxx xx xx"
        maskVal     = "client-number"
        name        = "client_number"
        ref         = "clientNumberInput"
        disabled    = "inputDisabled"
        @onComplete = "getValue"
        @onAccept   = "clearValue"
    />
    <input-password
        label       = "Пароль"
        required    = "*"
        :errorText  = "authErrors.password ? authErrors.password[0] : ''"
        placeholder = "Пароль"
        name        = "password"
        ref         = "passwordInput"
        @onComplete = "getValue"
    />
    <p
        v-if="authErrors.message"
        class="input-error"
    >{{authErrors.message}}</p>

    <div class="reg-auth__button">
        <orange-button
            text            = "Войти"
            @click.prevent  = "login"
            ref             = "submitButton"
        />
        <div class="flex reg-auth__links">
            <a href="#" @click.prevent="showForgotPasswordModal">Забыли пароль?</a>
            <a href="#" class="reg-auth__client-back" @click.prevent="$emit('back-to-phone-login')">Вход по номеру телефона</a>
        </div>
    </div>
    <transition name="fade">
        <div v-if="forgotPasswordModalShow" class="overlay">
            <div class="modal-wrap">
                <div class="modal-win">
                    <a
                        href="#"
                        class="modal-close"
                        @click.prevent="showForgotPasswordModal">
                        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 8.5L17 2.5C17.5523 1.94772 17.5523 1.05228 17 0.5C16.4477 -0.0522847 15.5523 -0.0522853 15 0.5L9 6.5L3 0.5C2.44772 -0.0522845 1.55229 -0.0522848 1 0.5C0.447716 1.05229 0.447715 1.94771 1 2.5L7 8.5L0.999999 14.5C0.447715 15.0523 0.447715 15.9477 1 16.5C1.55228 17.0523 2.44771 17.0523 3 16.5L9 10.5L15 16.5C15.5523 17.0523 16.4477 17.0523 17 16.5C17.5523 15.9477 17.5523 15.0523 17 14.5L11 8.5Z"></path>
                        </svg>
                    </a>
                    <div class="forgot-password-client">
                        <div class="modal-title">Восстановление пароля</div>
                        <p class="forgot-password-client__text">
                            Вход по номеру клиента больше не поддерживается.<br>
                            Пожалуйста, войдите или зарегистрируйтесь через новую версию личного кабинета.
                        </p>
                        <div class="forgot-password-client__buttons flex">
                            <orange-button
                                text="Войти"
                                @click.prevent="switchToPhoneLogin"
                            />
                            <orange-button
                                text="Регистрация"
                                @click.prevent="switchToRegister"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import InputText from '@/components/UI/InputText'
import InputPassword from '@/components/UI/InputPassword'
import OrangeButton from '@/components/UI/OrangeButton'

export default {
    name: 'client-login-form',
    emits: ['back-to-phone-login', 'switch-to-phone-login', 'switch-to-register'],
    props: {
        isAuthMp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            client_number: '',
            password: '',
            inputDisabled: false,
            forgotPasswordModalShow: false,
        }
    },
    components: {
        InputText,
        InputPassword,
        OrangeButton,
    },
    computed: {
        authErrors() {
            if (this.$store.state.authErrors)
                this.setInputDisabled(false)
            else if (this.$store.state.authStatus)
                this.$router.push('/')

            return this.$store.state.authErrors
        }
    },
    methods: {
        getValue(e) {
            if (e.name == 'client_number')
                this.client_number = e.value

            if (e.name == 'password')
                this.password = e.value
        },
        clearValue() {
            this.client_number = ''
        },
        login() {
            this.$store.commit('loginOld', {
                login: this.client_number,
                password: this.password,
                fromAuthMp: this.isAuthMp,
            })
            this.setInputDisabled(true)
        },
        setInputDisabled(status) {
            if (this.$refs.submitButton)
                this.$refs.submitButton.setDisabled(status)
        },
        showForgotPasswordModal() {
            this.forgotPasswordModalShow = !this.forgotPasswordModalShow
        },
        switchToPhoneLogin() {
            this.forgotPasswordModalShow = false
            this.$emit('switch-to-phone-login')
        },
        switchToRegister() {
            this.forgotPasswordModalShow = false
            this.$emit('switch-to-register')
        }
    }
}
</script>
